import Vue from 'vue'

Vue.prototype.$chart = {
  /*
  * 柱状图bar以及折线图混合
  * xData, x轴的数据：[]
  * seriesData, y轴数据： [{
      name: '', // 图表名称
      type: '', // 图表类型(echart类型一致)：bar,line
      unit: '%',// 单位
      data: [], // y数据
      itemColor: '' // 颜色设置
      emphasisColor: '' // 选中颜色设置
  * }]
  * isShowLegend: 是否显示图例
  * isDataZoomShow： 是否出现滚动条
  */
  mixBarLineChart(xData, yAxis, seriesData, isShowLegend, dataZoomObj = {}, gridObj = {}, legendObj = {}, xAxis = [], yAxisTotal = 2) {
    // 是否展示滚动条
    const isDataZoomShow = dataZoomObj.show || false
    // 当前展示多少个值或柱子
    const dataZoomLg = dataZoomObj.dataZoomLg
    // 滚动条从哪里开始
    const dataZoomsStart = seriesData.length ? (parseInt((dataZoomLg || 30) / seriesData[0].data.length * 100)) : 100
    // 不同类型的不同样式
    const seriesStyles = [
      {
        type: 'bar',
        barMinWidth: 4,
        barMaxWidth: 20,
        itemStyle: {
          normal: {
            color: '#C7D6FF'
          }
        },
        emphasis: {
          itemStyle: {
            color: '#4764ED',
            borderColor: '#4764ED'
          }
        }
      },
      {
        type: 'line',
        symbol: 'circle',
        symbolSize: 2,
        itemStyle: {
          normal: {
            color: '#478500'
          }
        }
      }
    ]
    const legendData = seriesData.map(item => item.name)
    const seriesDatas = seriesData.map(item => {
      const obj = seriesStyles.find(elem => elem.type === item.type) || {}
      const seriesItem = JSON.parse(JSON.stringify(obj))
      // 颜色设置
      if (item.itemColor) {
        seriesItem.itemStyle.normal.color = item.itemColor
      }
      // 选中颜色设置
      if (item.emphasisColor) {
        seriesItem.emphasis.itemStyle.color = item.emphasisColor
        seriesItem.emphasis.itemStyle.borderColor = item.emphasisColor
      }
      return Object.assign(seriesItem, item)
    })
    // xAxis X轴处理
    const xAxisObj = {
      type: 'category',
      data: xData || [],
      axisTick: {
        show: false,
        lineStyle: {
          color: '#BFBFBF',
          heigh: 50
        }
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: '#ddd',
          width: 2
        }
      },
      axisLabel: {
        color: '#767676'
      }
    }
    let xAxisArr = []
    if (xAxis.length) {
      xAxisArr = xAxis.map(item => {
        const obj = Object.assign(JSON.parse(JSON.stringify(xAxisObj)), item)
        return obj
      })
    } else {
      xAxisArr = [xAxisObj]
    }
    // yAxis Y轴处理
    const yAxisObj = {
      type: 'value',
      min: 0,
      minInterval: 1,
      nameTextStyle: {
        fontSize: 12,
        color: '#999',
        padding: [0, 0, 15, 25]
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#E9E9E9',
          type: 'dashed'
        }
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        formatter: '{value}'
      }
    }
    const yAxisObj1 = Object.assign(JSON.parse(JSON.stringify(yAxisObj)), {
      nameTextStyle: {
        fontSize: 12,
        color: '#999',
        padding: [0, 0, 15, -25]
      }
    })
    let yAxisArr = yAxisTotal > 1 ? [yAxisObj1, yAxisObj] : [yAxisObj1]
    if (yAxis && yAxis.length) {
      yAxisArr = yAxisArr.map((item, index) => {
        if (yAxis.length > index) item = Object.assign(item, yAxis[index])
        return JSON.parse(JSON.stringify(item))
      })
    }
    return {
      grid: Object.assign({
        top: 30,
        left: 30,
        right: 30,
        bottom: isDataZoomShow ? 90 : 50,
        containLabel: true
      }, gridObj),
      legend: Object.assign({
        show: isShowLegend,
        data: legendData,
        bottom: 10
      }, legendObj),
      xAxis: xAxisArr,
      yAxis: yAxisArr,
      dataZoom: [Object.assign({
        show: isDataZoomShow || false,
        start: isDataZoomShow ? (dataZoomsStart > 100 ? 0 : (100 - dataZoomsStart)) : 0,
        zoomLock: false,
        end: 100,
        height: 15,
        left: yAxisArr.length > 1 ? 40 : 48,
        right: yAxisArr.length > 1 ? 45 : 35,
        bottom: 60,
        backgroundColor: 'rgb(244, 249, 255)',
        fillerColor: '#dcebff',
        borderColor: '#ddd'
      }, dataZoomObj)],
      tooltip: {
        trigger: 'axis',
        padding: [10, 15, 10, 15],
        backgroundColor: '#ffffff',
        borderColor: '#ffffff',
        extraCssText: 'box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);',
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: '#E6EBF0'
          }
        },
        formatter: (params) => {
          let name = params[0].name
          if (params[0].data && params[0].data.xdata) {
            name = params[0].data.xdata
          }
          const title = '<span style="color:#767676">' + name + '<br /></span>'
          const seriesStr = params.reduce((str, item) => {
            const itemSeries = seriesData.find(elem => elem.name === item.seriesName && elem.type === item.seriesType) || {}
            let symbol = ''
            if (itemSeries.type === 'bar') {
              symbol = '<span style="display: inline-block;width: 12px; height: 10px; margin-right: 8px; border-radius: 4px; background-color:' + item.color + '"></span>'
            } else if (itemSeries.type === 'line') {
              symbol = '<span style="display: inline-block;width: 12px; height: 2px; margin-right: 8px; border-radius: 4px; background-color:' + item.color + '"></span>'
            }
            let value = String(item.value || 0)
            // 判断小数点后有几位
            const pointLg = value.indexOf('.') > 0 ? value.split('.')[1].length : 0
            if (pointLg > 2) value = item.value ? item.value.toFixed(1) : 0
            str += '<p style="color: #222;font-size: 14px; display: flex; align-items: center;">' + symbol + item.seriesName + '：' + value + (itemSeries.unit || '') + '</p>'
            return str
          }, '')
          return title + seriesStr
        }
      },
      series: seriesDatas
    }
  },
  /*
  * 环形图
  * xData, x轴的数据：[]
  * seriesData, y轴数据： [{
      name: '', // 图表名称
      type: '', // 图表类型(echart类型一致)：bar,line
      unit: '%',// 单位
      data: [], // y数据
      total: '' // 总数
  * }]
  * isShowLegend: 是否显示图例
  * isRadius： 是否是环形
  * radius：环形展示比例
  */
  pieChart(seriesData, pieColor, isShowLegend, tooltipObj = {}, isShowCenter) {
    const seriesStyles = [{
      type: 'pie',
      radius: [60, 90],
      center: ['50%', '50%'],
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      avoidLabelOverlap: false,
      label: {
        show: !!isShowCenter,
        position: 'center',
        color: '#767676',
        fontSize: 14,
        lineHeight: '24',
        overflow: 'break',
        formatter: (params) => {
          let arr = []
          if (seriesData[0].total) {
            arr = [
              '{a|' + seriesData[0].total + '}',
              '{b|' + params.seriesName + '}'
            ]
          } else {
            arr = [
              '{b|' + params.seriesName + '}'
            ]
          }
          return arr.join('\n')
        },
        rich: {
          a: {
            color: '#222222',
            fontSize: 18
          },
          b: {
            color: '#767676',
            fontSize: 14
          }
        }
      },
      labelLine: {
        show: false
      }
    }]
    // 选中颜色设置
    const seriesEmphasis = {
      emphasis: {
        itemStyle: {
          color: '',
          borderColor: ''
        }
      }
    }
    const seriesDatas = seriesData.map(item => {
      const itemStyle = seriesStyles.find(elem => elem.type === item.type) || {}
      // 选中颜色设置
      if (item.data && item.data.length > 0) {
        item.data = item.data.map((elem, i) => {
          // 选中颜色设置
          elem = Object.assign(JSON.parse(JSON.stringify(seriesEmphasis)), elem)
          if (elem.emphasisColor) {
            elem.emphasis.itemStyle.color = elem.emphasisColor
            elem.emphasis.itemStyle.borderColor = elem.emphasisColor
          } else {
            elem.emphasis.itemStyle.color = (pieColor.length >= i + 1) ? pieColor[i] : ''
            elem.emphasis.itemStyle.borderColor = (pieColor.length >= i + 1) ? pieColor[i] : ''
          }
          return elem
        })
      }
      return Object.assign(itemStyle, item)
    })
    return {
      grid: {
        top: 0,
        bottom: 0,
        right: 30,
        left: 30
      },
      tooltip: Object.assign({
        trigger: 'item',
        padding: [10, 15, 10, 15],
        backgroundColor: '#ffffff',
        borderColor: '#ffffff',
        extraCssText: 'box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);',
        formatter: (params) => {
          const item = params.data || {}
          if (!item.name) return
          const title = '<span style="color:#767676">' + (params.seriesName || item.name) + '<br /></span>'
          const symbol = '<span style="display: inline-block;width: 12px; height: 10px; margin-right: 8px; border-radius: 4px; background-color:' + params.color + '"></span>'
          const seriesStr = '<p style="color: #222;font-size: 14px; display: flex; align-items: center;">' + symbol + item.name + '：' + item.value + (item.unit || '') + '</p>'
          return title + seriesStr
        }
      }, tooltipObj),
      legend: {
        show: isShowLegend,
        top: '0%',
        left: 'center'
      },
      color: pieColor || [],
      series: seriesDatas
    }
  },
  // 条形
  barChart(xData, yAxis, seriesData, isShowLegend, dataZoomObj = {}, gridObj = {}, legendObj = {}, xAxis = []) {
    // 是否展示滚动条
    const isDataZoomShow = dataZoomObj.show || false
    // 当前展示多少个值或柱子
    const dataZoomLg = dataZoomObj.dataZoomLg
    // 滚动条从哪里开始
    const dataZoomsStart = parseInt((dataZoomLg || 30) / seriesData[0].data.length * 100)
    // 不同类型的不同样式
    const seriesStyles = [{
      type: 'bar',
      barMinWidth: 4,
      barMaxWidth: 16,
      itemStyle: {
        normal: {
          color: '#C7D6FF'
        }
      },
      emphasis: {
        itemStyle: {
          color: '#4764ED',
          borderColor: '#4764ED'
        }
      }
    }]
    const legendData = seriesData.map(item => item.name)
    const seriesDatas = seriesData.map(item => {
      const obj = seriesStyles.find(elem => elem.type === item.type) || {}
      const seriesItem = JSON.parse(JSON.stringify(obj))
      // 颜色设置
      if (item.itemColor) {
        seriesItem.itemStyle.normal.color = item.itemColor
      }
      // 选中颜色设置
      if (item.emphasisColor) {
        seriesItem.emphasis.itemStyle.color = item.emphasisColor
        seriesItem.emphasis.itemStyle.borderColor = item.emphasisColor
      }
      return Object.assign(seriesItem, item)
    })
    // xAxis X轴处理
    const xAxisObj = {
      type: 'category',
      data: xData || [],
      axisTick: {
        show: false,
        lineStyle: {
          color: '#BFBFBF',
          heigh: 50
        }
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: '#ddd',
          width: 2
        }
      },
      axisLabel: {
        color: '#767676'
      }
    }
    let xAxisArr = []
    if (xAxis.length) {
      xAxisArr = xAxis.map(item => {
        const obj = Object.assign(JSON.parse(JSON.stringify(xAxisObj)), item)
        return obj
      })
    } else {
      xAxisArr = [xAxisObj]
    }
    // yAxis Y轴处理
    const yAxisObj = {
      type: 'value',
      min: 0,
      minInterval: 1,
      nameGap: 10,
      nameLocation: 'end',
      nameTextStyle: {
        fontSize: 12,
        color: '#999',
        padding: [0, 0, 10, -20]
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: '#E9E9E9',
          type: 'dashed'
        }
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        formatter: '{value}'
      }
    }
    let yAxisArr = [yAxisObj]
    if (yAxis && yAxis.length) {
      yAxisArr = yAxisArr.map((item, index) => {
        if (yAxis.length > index) item = Object.assign(item, yAxis[index])
        return JSON.parse(JSON.stringify(item))
      })
    }
    return {
      grid: Object.assign({
        top: 30,
        left: '0%',
        right: '0%',
        bottom: isDataZoomShow ? 90 : 50,
        containLabel: true
      }, gridObj),
      legend: Object.assign({
        show: isShowLegend,
        data: legendData,
        bottom: 10
      }, legendObj),
      xAxis: xAxisArr,
      yAxis: yAxisArr,
      // yAxis: [{
      //   type: 'value',
      //   min: 0,
      //   minInterval: 1,
      //   axisTick: {
      //     show: false
      //   },
      //   axisLine: {
      //     show: false
      //   },
      //   splitLine: {
      //     show: true,
      //     lineStyle: {
      //       color: '#E9E9E9',
      //       type: 'dashed'
      //     }
      //   }
      // }],
      dataZoom: [Object.assign({
        show: isDataZoomShow || false,
        start: isDataZoomShow ? (dataZoomsStart > 100 ? 0 : (100 - dataZoomsStart)) : 0,
        zoomLock: false,
        end: 100,
        height: 15,
        left: 40,
        right: 30,
        bottom: 60,
        backgroundColor: 'rgb(244, 249, 255)',
        fillerColor: '#dcebff',
        borderColor: '#ddd'
      }, dataZoomObj)],
      tooltip: {
        trigger: 'axis',
        padding: [10, 15, 10, 15],
        backgroundColor: '#ffffff',
        borderColor: '#ffffff',
        extraCssText: 'box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);',
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: '#E6EBF0'
          }
        },
        formatter: (params) => {
          let name = seriesData[0].formatName ? seriesData[0].formatName.replace('x', params[0].name) : params[0].name
          if (params[0].data && params[0].data.xdata) {
            name = params[0].data.xdata
          }
          const title = '<span style="color:#767676">' + name + '<br /></span>'
          const seriesStr = params.reduce((str, item) => {
            const itemSeries = seriesData.find(elem => elem.name === item.seriesName && elem.type === item.seriesType) || {}
            const symbol = '<span style="display: inline-block;width: 12px; height: 10px; margin-right: 8px; border-radius: 4px; background-color:' + item.color + '"></span>'
            let value = String(item.value || 0)
            // 判断小数点后有几位
            const pointLg = value.indexOf('.') > 0 ? value.split('.')[1].length : 0
            if (pointLg > 2) value = item.value ? item.value.toFixed(1) : 0
            str += '<p style="color: #222;font-size: 14px; display: flex; align-items: center;">' + symbol + item.seriesName + '：' + value + (itemSeries.unit || '') + '</p>'
            return str
          }, '')
          return title + seriesStr
        }
      },
      series: seriesDatas
    }
  },
  // 条形
  columnChart(xData, seriesData, isShowLegend) {
    // 不同类型的不同样式
    const seriesStyles = [{
      type: 'bar',
      barMinWidth: 4,
      barMaxWidth: 20,
      itemStyle: {
        normal: {
          color: '#C7D6FF'
        }
      },
      emphasis: {
        itemStyle: {
          color: '#4764ED',
          borderColor: '#4764ED'
        }
      }
    }]
    const legendData = seriesData.map(item => item.name)
    const seriesDatas = seriesData.map(item => {
      const obj = seriesStyles.find(elem => elem.type === item.type) || {}
      const seriesItem = JSON.parse(JSON.stringify(obj))
      // 颜色设置
      if (item.itemColor) {
        seriesItem.itemStyle.normal.color = item.itemColor
      }
      // 选中颜色设置
      if (item.emphasisColor) {
        seriesItem.emphasis.itemStyle.color = item.emphasisColor
        seriesItem.emphasis.itemStyle.borderColor = item.emphasisColor
      }
      return Object.assign(seriesItem, item)
    })
    return {
      grid: {
        top: 10,
        left: 30,
        right: 100,
        bottom: 50,
        containLabel: true
      },
      legend: {
        show: isShowLegend,
        data: legendData,
        bottom: 10
      },
      xAxis: [{
        type: 'value',
        min: 0,
        minInterval: 1,
        splitNumber: 9,
        axisTick: {
          show: true
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#E9E9E9',
            type: 'solid'
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#E9E9E9',
            type: 'solid'
          }
        },
        axisLabel: {
          show: true,
          color: '#767676'
        }
      }],
      yAxis: [{
        type: 'category',
        data: xData || [],
        inverse: true,
        axisTick: {
          show: false
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: '#ddd',
            width: 2
          }
        },
        axisLabel: {
          width: 50,
          color: '#767676',
          overflow: 'truncate',
          ellipsis: '...',
          formatter: (name) => {
            const title = name.length > 15 ? name.substr(0, 15) + '...' : name
            return title
          }
        }
      }],
      tooltip: {
        trigger: 'axis',
        padding: [10, 15, 10, 15],
        backgroundColor: '#ffffff',
        borderColor: '#ffffff',
        extraCssText: 'box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);',
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: '#E6EBF0'
          }
        },
        formatter: (params) => {
          const name = seriesData[0].formatName ? seriesData[0].formatName.replace('x', params[0].name) : params[0].name
          const title = '<span style="color:#767676">' + name + '<br /></span>'
          const seriesStr = params.reduce((str, item) => {
            const itemSeries = seriesData.find(elem => elem.name === item.seriesName && elem.type === item.seriesType) || {}
            const symbol = '<span style="display: inline-block;width: 12px; height: 10px; margin-right: 8px; border-radius: 4px; background-color:' + item.color + '"></span>'
            let value = String(item.value || 0)
            // 判断小数点后有几位
            const pointLg = value.indexOf('.') > 0 ? value.split('.')[1].length : 0
            if (pointLg > 2) value = item.value ? item.value.toFixed(1) : 0
            str += '<p style="color: #222;font-size: 14px; display: flex; align-items: center; margin-top: 5px">' + symbol + item.seriesName + '：' + value + (itemSeries.unit || '') + '</p>'
            // 如果有占比，则需要添加占比
            if (item.data.rate) {
              str += '<p style="color: #222;font-size: 14px; display: flex; align-items: center; margin-top: 4px">' + symbol + '占比：' + item.data.rate + '</p>'
            }
            return str
          }, '')
          return title + seriesStr
        }
      },
      series: seriesDatas
    }
  },
  // 矩形树图
  treemapChart(seriesData) {
    return {
      grid: {
        top: 0,
        left: 20,
        right: 20,
        bottom: 30,
        containLabel: true
      },
      legend: {
        show: false
      },
      series: [
        {
          type: 'treemap',
          name: '',
          width: '100%',
          height: '100%',
          breadcrumb: {
            show: false
          },
          squareRatio: Math.sqrt(5),
          nodeClick: false,
          roam: false,
          sort: false,
          colorSaturation: [0.3, 1],
          emphasis: {
            itemStyle: {
              color: 'rgb(113, 152, 247)'
            }
          },
          select: {
            itemStyle: {
              color: 'rgb(113, 152, 247)'
            }
          },
          data: seriesData
        }
      ]
    }
  },
  // x轴数据处理
  getXAxis(xData, id) {
    // 初始化设置x轴
    let xAxis = [{
      data: xData,
      nameTextStyle: {
        padding: [20, 0]
      },
      axisTick: {
        show: true
      }
    }]
    // 如果是季度，则需要展示二级x坐标轴
    if (id === 'Q') {
      // 一级坐标轴值处理
      const firstXData = []
      // 获取二级坐标轴的值
      const arr = JSON.parse(JSON.stringify(xData))
      const secondXData = arr.reduce((preArr, item) => {
        const year = item.value.substr(0, 4)
        // 一级坐标轴
        const value = item.value.replace(year, '')
        firstXData.push({
          value: value,
          date: item.value,
          textStyle: {
            fontSize: 14,
            lineHeight: 24
          }
        })
        // 二级坐标轴
        const isExit = preArr.some(elem => elem.value === year)
        if (!isExit) {
          preArr.push({
            value: year,
            date: item.value,
            textStyle: {
              fontSize: 14,
              lineHeight: 24
            }
          })
        }
        return preArr
      }, [])
      // 所有x轴的数据
      xAxis = [{
        data: firstXData
      }, {
        type: 'category',
        data: secondXData,
        position: 'bottom',
        offset: 0,
        axisLine: {
          show: false
        },
        axisLabel: {
          color: '#767676',
          margin: 35 // 文字与坐标轴的间隔
        },
        axisTick: {
          length: 60,
          lineStyle: {
            color: '#BFBFBF'
          }
        }
      }]
    }
    return xAxis
  },
  // 中国地图
  chinaMap(title, mapType, seriesData, color, pieces, min, max) {
    return {
      title: {
        text: title || '',
        textStyle: {
          color: '#333',
          fontSize: 12,
          fontWeight: 'normal'
        },
        bottom: 70
      },
      tooltip: {
        trigger: 'item',
        formatter: '{b}<br />' + title + '：{c}'
      },
      visualMap: {
        min: min,
        max: max,
        text: ['高', '低'],
        left: '0',
        bottom: '45',
        splitNumber: 5,
        itemWidth: 10,
        itemHeight: 10,
        orient: 'horizontal',
        inverse: true,
        color: color || [],
        pieces: pieces || [],
        formatter: function(e) {
        }
      },
      series: [{
        name: mapType || 'china',
        type: 'map',
        mapType: mapType || 'china', // 自定义扩展图表类型
        itemStyle: {
          normal: {
            borderWidth: 1,
            borderColor: '#fff',
            shadowColor: '#fff'
          },
          emphasis: {
            areaColor: '#eff',
            borderColor: '#fff',
            width: 1
          }
        },
        label: {
          show: false
        },
        data: seriesData || []
      }]
    }
  }
}
